import React from "react";
import { ColoredSpan, Button } from "../../components";
import { useSelector } from "react-redux";
import { Modal } from "../../components/modal";

const CommonToAllModalHelp = ({ openModal, setOpenModal }) => {
  const inspectionSymbol = useSelector(
    (s) => s.app_settings.inspection_display.inspection_result_symbol
  );
  const data = [
    {
      status: "点検OK",
      value: "5.5kf/cm²",
      color: inspectionSymbol.passed.color,
      background: inspectionSymbol.passed.background,
      symbol: inspectionSymbol.passed.symbol,
    },
    {
      status: "点検NG",
      value: "7.0kgf/cm²",
      color: inspectionSymbol.failed.color,
      background: inspectionSymbol.failed.background,
      symbol: inspectionSymbol.failed.symbol,
    },
    {
      status: "処置済点検OK",
      value: "5.5kgf/cm²",
      color: inspectionSymbol.treatment_completed.color,
      background: inspectionSymbol.treatment_completed.background,
      symbol: inspectionSymbol.treatment_completed.symbol,
    },
    {
      status: "OKNG対象外",
      value: "□□は△△であって",
      subValue: "□□は30",
      color: inspectionSymbol.other_okng.color,
      background: inspectionSymbol.other_okng.background,
      symbol: inspectionSymbol.other_okng.symbol,
    },
  ];

  return (
    <Modal show={openModal} onClose={() => setOpenModal(false)} size="4xl">
      <Modal.Header>点検結果記号</Modal.Header>
      <Modal.Body>
        <div className="space-y-2">
          <span>本設定画面で設定する各項目は、以下のように紐づきます。</span>
          <div className="py-2">
            <span className="font-bold">■設定例</span>
          </div>
        </div>
        <div className="flex space-x-10">
          <table className="text-left border-r border-tenken-gray-300">
            <thead>
              <tr>
                <th></th>
                <th className="border border-tenken-gray-300 pl-10 pr-28 py-2 bg-tenken-gray-300">
                  点検結果
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  <td className="px-4 py-2">
                    <div className="flex items-center justify-end">
                      <span className="mr-6">{item.status}</span>
                      <div className="w-10 h-[1px] border border-[#2E90FA] absolute left-[144px]"></div>
                    </div>
                  </td>
                  <td className="p-0">
                    <div>
                      <div className="bg-white px-1 pt-1.5">
                        <ColoredSpan
                          className="py-1 border-x align-middle border-t border-tenken-gray-300 inline-block w-10 h-8 text-center"
                          color={item.color}
                          background={item.symbol ? item.background : ""}
                        >
                          {item.symbol ? item.symbol : " "}
                        </ColoredSpan>
                        {item.subValue && (
                          <span class="ml-2">{item.subValue}</span>
                        )}
                      </div>
                      <div className="bg-gray-50 px-1">
                        <ColoredSpan
                          className="py-1 border-x border-b align-middle border-tenken-gray-300 inline-block w-10 h-8 text-center"
                          color={item.color}
                          background={item.symbol ? item.background : ""}
                        >
                          {item.symbol ? item.symbol : " "}
                        </ColoredSpan>
                        <span class="ml-2">{item.value}</span>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <table className="text-left border-r border-tenken-gray-300">
            <thead>
              <tr>
                <th></th>
                <th className="border border-tenken-gray-300 pl-10 pr-28 py-2 bg-tenken-gray-300">
                  点検結果
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="px-4 py-2">
                  <div className="flex items-center justify-end">
                    <span className="mr-6">未点検 / 未承認</span>
                    <div className="w-10 h-[1px] border border-[#2E90FA] absolute right-[256px]"></div>
                  </div>
                </td>
                <td className="p-0">
                  {data.map((item, index) => (
                    <div key={index}>
                      <div className="bg-white px-1">
                        <ColoredSpan
                          className={`py-1 align-middle inline-block w-10 h-8 text-center border-x ${
                            item.status === "点検OK" ? "border-t" : ""
                          } border-tenken-gray-300`}
                          color={inspectionSymbol.not_inspected.color}
                          background={
                            inspectionSymbol.not_inspected.symbol
                              ? inspectionSymbol.not_inspected.background
                              : ""
                          }
                        >
                          {inspectionSymbol.not_inspected.symbol
                            ? inspectionSymbol.not_inspected.symbol
                            : " "}
                        </ColoredSpan>
                      </div>
                      <div className="bg-gray-50 px-1">
                        <ColoredSpan
                          className={`py-1 align-middle inline-block w-10 h-8 text-center border-x ${
                            item.status === "OKNG対象外" ? "border-b" : ""
                          } border-tenken-gray-300`}
                          color={inspectionSymbol.not_inspected.color}
                          background={
                            inspectionSymbol.not_inspected.symbol
                              ? inspectionSymbol.not_inspected.background
                              : ""
                          }
                        >
                          {inspectionSymbol.not_inspected.symbol
                            ? inspectionSymbol.not_inspected.symbol
                            : " "}
                        </ColoredSpan>
                      </div>
                    </div>
                  ))}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="w-full flex justify-end px-2">
          <Button
            color="reset"
            className="min-w-[160px]"
            children="閉じる"
            onClick={() => setOpenModal(false)}
          />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default CommonToAllModalHelp;
